import jQuery from "jquery";

/**
 * Add toggle functionality to the Expandable List widget.
 *
 * @export
 */
export default function() {
  const $ = jQuery;

  // breadrumbs
  const $breadrumbs = $(".mg-breadcrumb");
  const $activeBreadcrumb = $breadrumbs.find(".is-active");
  const activeBreadcrumbText = $.trim($activeBreadcrumb.text()).toLowerCase();
  if (activeBreadcrumbText == "content") {
    $activeBreadcrumb.remove();
    $breadrumbs.find("li").last().find("span").remove();
  }

  $(document)
    .on("click", ".nav-toggle", function() {
      var $this = $(this);
      $this.siblings(".nav-menu").toggleClass("is-active");
    })
    .on("click", "[data-toggle=dropdown]", function() {
      $(this)
        .children()
        .toggleClass("fa-caret-down fa-caret-up")
        .closest(".nav-item")
        .toggleClass("is-expanded");
    });
}



// WEBPACK FOOTER //
// ./assets/src/js/components/nav.js